export const getCompanyName = (company: any) => company.name;
